import React from 'react';
import { grey, red } from '@mui/material/colors';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing';
import { IndicatorMenu, IndicatorMenuOption } from 'components/shared/IndicatorMenu';
import { AttributeFieldProps, StagesFormValues } from 'modules/stages/types';

type RequiredValue = 'required' | 'optional';

export const AttributeRequiredNode = ({ attributeIndex, rowIndex, prefix, disabled }: AttributeFieldProps) => {
  const { control, setValue } = useFormContext<ListingForm<StagesFormValues>>();

  const isRequired = useWatch({
    control,
    name: `bodyFields.${rowIndex}.${prefix}.${attributeIndex}.isRequired`,
  });

  const options: IndicatorMenuOption<RequiredValue>[] = [
    { value: 'optional', label: 'Optional', color: grey[200], disabled },
    { value: 'required', label: 'Required', color: red[500], disabled },
  ];

  return (
    <IndicatorMenu
      value={isRequired ? 'required' : 'optional'}
      options={options}
      onChange={next => setValue(`bodyFields.${rowIndex}.${prefix}.${attributeIndex}.isRequired`, next === 'required')}
    />
  );
};
